module.exports = __webpack_public_path__ + "static/media/label-10.b5bbb06c.svg";